import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultValue", "disabled", "id", "name", "onSelect", "options", "UNSAFE_touchableProps", "useSelectorLogo", "testID", "value"];
import React from 'react';
import useUncontrolledProp from '@bubble-ui/hook-use-uncontrolled-prop';
import { useUniqueFormIdentifier } from '@bubble-ui/hook-use-unique-form-identifier';
import View from '@bubble-ui/primitive-view';
import BaseSelectorOptionsOption from '@bubble-ui/temp-base-selector-options-option';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { getIds } from './getIds';
var SelectorOptions = _ref => {
  var {
      defaultValue,
      disabled,
      id,
      name,
      onSelect,
      options,
      UNSAFE_touchableProps,
      useSelectorLogo,
      testID,
      value
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SelectorOptions',
    props,
    useInstead: 'UNSAFE_touchableProps',
    removalDate: 'v7.0.0'
  });
  var ids = getIds(id);
  var componentName = useUniqueFormIdentifier({
    name,
    fallbackName: 'SelectorOptions'
  });
  var [selectorValue, setSelectorValue] = useUncontrolledProp({
    prop: value,
    defaultProp: defaultValue,
    onChange: onSelect
  });
  return /*#__PURE__*/React.createElement(View, {
    id: ids.root
  }, options.map((option, index) => /*#__PURE__*/React.createElement(BaseSelectorOptionsOption, _extends({
    UNSAFE_touchableProps: UNSAFE_touchableProps,
    radio: true,
    useSelectorLogo: useSelectorLogo,
    id: ids.option(index),
    testID: testID,
    isChecked: option.value === selectorValue,
    onClick: setSelectorValue,
    key: "".concat(option.value, "-").concat(index),
    isLast: index + 1 === options.length,
    name: componentName
  }, option, props, {
    disabled: disabled || option.disabled
  }))));
};
SelectorOptions.displayName = 'SelectorOptions';
export default SelectorOptions;
//# sourceMappingURL=index.js.map